import { render, staticRenderFns } from "./IconMenuAlt4Outline.vue?vue&type=template&id=62ad7942"
import script from "./IconMenuAlt4Outline.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt4Outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports